import React, { useState } from "react";
import { ButtonBack, ButtonNext, CarouselProvider, Slider, Slide, Dot, } from "pure-react-carousel";
import ImgChevronNext from "../images/ico-hero-next.png";
import ImgChevronPrev from "../images/ico-hero-prev.png";
import { NavLink } from "react-router";
import { gql, useQuery } from "@apollo/client";
import { HandleQuery } from "../queries";

export default function HomePageSlider(props)
{
    const [data, setData] = useState(props.data);

    return (
      <CarouselProvider
        totalSlides={data.length}
        visibleSlides={1}
        step={1}
        isPlaying={true}
        infinite={true}
        interval={5000}
        isIntrinsicHeight={true}
      >
        <section className="hero">
          <div>
            <div className="hero__top">
              <div className="slider slider-hero">
                <div>
                  <div style={{ width: "100%", minHeight: "600px" }}>
                    <Slider style={{ minHeight: "600px", width: "100%" }}>
                      {data.map((item, i) => {
                        // TODO: need to use a proper background image component

                        const query_state = useQuery(gql`
                            query 
                            {
                                asset(id: ${item.image[0].id}) @transform(format: "webp", width: 1280, height: 600, mode: "crop", quality: 75, position: "top-center")
                                {
                                    url
                                }
                            }
                        `);

                        const { complete, view } = HandleQuery(query_state);
                        if(!complete) return view;
                        const data = query_state.data; 
                        const image = "https://cms.genesis-analytics.com" + data.asset.url;

                        return (
                          <Slide
                            index={i}
                            key={i}
                            style={{
                              backgroundImage: "url(" + image + ")",
                              backgroundSize: "cover",
                              minHeight: "600px",
                            }}
                          >
                            <div className="shell hero-slide-shell">
                              <div>
                                <div className="article-slider text-lato">
                                  <h1
                                    className="h1 article__title text-white"
                                    dangerouslySetInnerHTML={{
                                      __html: item.head,
                                    }}
                                  />

                                  <p
                                    className="article__subtitle h1 text-white carousel-subheading"
                                    dangerouslySetInnerHTML={{
                                      __html: item.subhead,
                                    }}
                                  />

                                  {item.customUrl ||
                                  item.relatedEntry.length > 0 ? (
                                    item.customUrl ? (
                                      <a
                                        className="article__link link-more link-more--white text-lato"
                                        href={item.customUrl}
                                      >
                                        {item.linkText
                                          ? item.linkText
                                          : "Read more"}
                                          <span className="sr-only">To learn more about this, click here.</span>
                                      </a>
                                    ) : (
                                      item.relatedEntry.length && (
                                        <NavLink
                                          className="article__link link-more link-more--white text-lato"
                                          to={`/${item.relatedEntry[0].uri}`}
                                        >
                                          {item.linkText
                                            ? item.linkText
                                            : "Read more"}
                                          <span className="sr-only">To learn more about this, click here.</span>
                                        </NavLink>
                                      )
                                    )
                                  ) : (
                                    <></>
                                  )}

                                  <br />

                                  {item.customUrl2 ||
                                  item.relatedEntry2.length > 0 ? (
                                    item.customUrl2 ? (
                                      <a
                                        className="article__link link-more link-more--white text-lato"
                                        href={item.customUrl2}
                                      >
                                        {item.linkText2
                                          ? item.linkText2
                                          : "Read more"}
                                          <span className="sr-only">To learn more about this, click here.</span>
                                      </a>
                                    ) : (
                                      item.relatedEntry2.length && (
                                        <NavLink
                                          className="article__link link-more link-more--white text-lato"
                                          to={`/${item.relatedEntry2[0].uri}`}
                                        >
                                          {item.linkText2
                                            ? item.linkText2
                                            : "Read more"}
                                          <span className="sr-only">To learn more about this, click here.</span>
                                        </NavLink>
                                      )
                                    )
                                  ) : (
                                    <></>
                                  )}
                                </div>
                              </div>
                            </div>
                          </Slide>
                        )
                      })}
                    </Slider>
                  </div>
                </div>
                <ButtonBack
                  className="swiper-button-prev slider__btn slider__btn--prev"
                  tabIndex={0}
                  role="button"
                  aria-label="Previous slide"
                  aria-disabled="false"
                >
                  <div>
                    <img src={ImgChevronPrev} alt="" className="w-6 h-6" />
                  </div>
                </ButtonBack>
                <ButtonNext
                  className="swiper-button-next slider__btn slider__btn--next"
                  tabIndex={-1}
                  role="button"
                  aria-label="Next slide"
                  aria-disabled="false"
                >
                  <div>
                    <img src={ImgChevronNext} alt="" className="w-6 h-6" />
                  </div>
                </ButtonNext>
              </div>
            </div>
            {props.alert ? (
              <div className="hero__bottom">
                <div className="shell">
                  <div className="hero__bottom-inner">
                    <ul
                      className={`articles-sm ${"article-sm-" +
                        data.length.toString()}`}
                    >
                      {data.map((item, i) => {
                        return (
                          <li key={item.id}>
                            <Dot slide={i} className="article-sm text-white">
                              <div className="article__entry">
                                <p className="article__title">{item.navText}</p>
                              </div>
                            </Dot>
                          </li>
                        )
                      })}
                    </ul>

                    <div className="message">
                      <div className="shell">
                        <div className="message__entry richtext-entry px-4">
                          <div
                            dangerouslySetInnerHTML={{
                              __html: props.alert,
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              <></>
            )}
          </div>
        </section>
      </CarouselProvider>
    );
}
